// Globals
import { ReactNode } from 'react';

// Components
import { FileUpload } from '@/components';
import { UploadIcon } from '@/icons';
import { UploadCard } from '../../components';
import { StyedWrapper, StyledIcon, StyledList } from './FilesListUploaderContainerStyles';

// Models
import { IFile } from '@/models/file.model';

type TFileUploaderContainerProps = {
  disabled?: boolean;
  children?: ReactNode;
  acceptance?: string;
  fileList?: IFile[];
  maxFileSize?: number;
  multiple?: boolean;
  onChange?: (file: File, fileList: File[]) => void;
  onPreview?: (file: IFile) => void;
  onDelete?: (file: IFile) => void;
  description?: ReactNode;
};

const FilesListUploaderContainer = ({
  onChange,
  disabled,
  children,
  acceptance,
  fileList = [],
  onPreview,
  onDelete,
  multiple,
  description,
  maxFileSize,
}: TFileUploaderContainerProps) => {
  if (fileList.length > 1) {
    return (
      <FileUpload
        onChange={onChange}
        maxFileSize={maxFileSize}
        disabled={disabled}
        acceptance={acceptance}
        showList={false}
        multiple={multiple}
        type="select"
      >
        {children}
        <StyledList>
          {fileList.map((file) => (
            <UploadCard key={file.id} file={file} onPreview={onPreview} onDelete={onDelete} />
          ))}
        </StyledList>
      </FileUpload>
    );
  }

  return (
    <FileUpload
      onChange={onChange}
      maxFileSize={maxFileSize}
      disabled={disabled}
      acceptance={acceptance}
      showList={false}
      multiple={multiple}
    >
      <StyedWrapper>
        {fileList.length ? (
          <>
            {fileList.map((file) => (
              <UploadCard key={file.id} file={file} onPreview={onPreview} onDelete={onDelete} />
            ))}
          </>
        ) : (
          <>
            <StyledIcon>
              <UploadIcon />
            </StyledIcon>
            {description}
          </>
        )}
      </StyedWrapper>
      {children}
    </FileUpload>
  );
};

export default FilesListUploaderContainer;
